"use client";

import * as React from 'react';

export const DEFAULT_MOBILE_VIEWPORT_BREAKPOINT = 768;

export function isMobileViewportWidth(width: number, breakpoint = DEFAULT_MOBILE_VIEWPORT_BREAKPOINT): boolean {
  return Number.isFinite(width) && width <= breakpoint;
}

/**
 * Lightweight viewport breakpoint hook used by the shadcn sidebar.
 * Defaults to `768px`, matching Tailwind's `md` breakpoint.
 */
export function useIsMobile(breakpoint = DEFAULT_MOBILE_VIEWPORT_BREAKPOINT) {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return isMobileViewportWidth(window.innerWidth, breakpoint);
  });

  React.useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const query = `(max-width: ${breakpoint}px)`;
    const mediaQuery = window.matchMedia(query);

    const handleChange = () => setIsMobile(mediaQuery.matches);
    handleChange();

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, [breakpoint]);

  return isMobile;
}
